export default {
  parametros: []
}
